import React, { useState, useEffect } from 'react';
import { useMyContext } from '../../../context/MyContext';
import NavBar from '../../../component/b2c/navBar/navBar';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import axios from 'axios';
import { FaUserPlus } from "react-icons/fa";
import { toast } from 'react-toastify';
import '../../../css/custom-scrollbar.css';
import { useNavigate } from 'react-router-dom';
import Select from "react-dropdown-select";
import { Base_Url, addEmployee } from '../../../config/config';
import { FiEye, FiEyeOff } from 'react-icons/fi';

const schema = z.object({
    name: z.string().min(1, "Name is required"),
    email: z.string().email("Invalid email address"),
    password: z.string().min(8, "Password must be at least 8 characters"),
    department: z.string().min(1, "Department is required"),
    phone: z.string().length(10, "Phone number must be 10 digits"),
    role: z.string().min(1, "Role is required"),
    company_name: z.string().min(1, "Company name is required")
});

const AddUser = () => {
    const token = localStorage.getItem('token');
    const naviagteToAllEmployee = useNavigate();
    const cus_id = localStorage.getItem('cus_id');
    const [showPassword, setShowPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { isToggleSidebar, isDarkMode } = useMyContext();
    const [roles, setRoles] = useState([
        { id: "PXROLE67e68d8fd9990", name: "Admin" },
        { id: "PXROLE67e68d8fd9991", name: "Manager" },
        { id: "PXROLE67e68d8fd9992", name: "Employee" }
    ]);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue
    } = useForm({
        resolver: zodResolver(schema),
        defaultValues: {
            name: "",
            email: "",
            password: "",
            department: "",
            phone: "",
            role: "",
            company_name: ""
        }
    });

    const onErrors = (errors) => {
        toast.error("Please fix the errors in the form.");
    };

    const handleInputChange = (event) => {
        const { value, id } = event.target;

        if (id === 'phone') {
            const filteredValue = value.replace(/[^0-9]/g, '');
            event.target.value = filteredValue;
        }

        if (['name', 'department', 'company_name'].includes(id)) {
            const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
            event.target.value = filteredValue;
        }
    };

    const handleSelectChange = (selectedValues) => {
        if (selectedValues && selectedValues.length > 0) {
            setValue('role', selectedValues[0].id);
        }
    };

    const navigate = useNavigate();

    const naviagation = () => {
        navigate('/dashboard');
    }

    const onSubmit = async (data, event) => {
        const apiurl = Base_Url + addEmployee;
        setIsSubmitting(true);
        try {
            const response = await axios.post(
                apiurl,
                data,
                {
                    headers: {
                        token,
                        'Content-Type': 'application/json',
                        cus_id: cus_id

                    }
                }
            );
            if (response.data.status === "SUCCESS") {
                toast.success(response.data.message);
                naviagteToAllEmployee("/allEmployee");
                reset();
                setIsSubmitting(false);
            }
            else {
                toast.error(response.data.message?.email || response.data.message?.password);
                setIsSubmitting(false);
            }
        } catch (error) {
            toast.error(error || error?.email?.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    const inputClass = (hasError) =>
        `appearance-none border w-full py-2 px-3 text-sm leading-tight rounded focus:outline-none focus:ring-1 focus:ring-black dark:focus:ring-white focus:border-black dark:focus:border-white transition-colors bg-white dark:bg-black text-black dark:text-white placeholder-gray-400 ${hasError ? 'border-black dark:border-white' : 'border-gray-300 dark:border-gray-700'
        }`;
    const labelClass = "block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1.5";
    const errorClass = "text-black dark:text-white text-[11px] mt-1";

    return (
        <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-white'}`}>
            <div className="z-10">
                <NavBar />
            </div>
            <div className="flex flex-1 overflow-hidden">
                {isToggleSidebar && (
                    <div
                        className={`fixed z-20 h-full w-64 md:relative duration-300 bg-white dark:bg-black dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20 border-r border-gray-200 dark:border-gray-800`}
                        style={
                            window.innerWidth < 768
                                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                                : {}
                        }
                    >
                        <Sidebar />
                    </div>
                )}
                <div className={`p-4 bg-gray-100 custom-scrollbar overflow-y-auto dark:bg-black ${isToggleSidebar ? 'ml-0' : 'mr-0'} w-full`}>
                    <div className="w-full mx-auto">
                        <button
                            className="flex justify-center w-full items-center mb-4 bg-slate-800 hover:opacity-80 text-white px-4 py-2.5 rounded-md transition-all">
                            <FaUserPlus className="text-sm text-white mr-2" />
                            <h2 className="text-sm font-semibold text-center">Add New User</h2>
                        </button>
                        <form onSubmit={handleSubmit(onSubmit, onErrors)} className="bg-white dark:bg-black dark:text-white border border-gray-200 dark:border-gray-800 rounded-md p-4 font-sans">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div>
                                    <label htmlFor="role" className={labelClass}>Select Role</label>
                                    <Select
                                        options={roles}
                                        labelField="name"
                                        valueField="id"
                                        style={{
                                            padding: '0.4rem',
                                            fontSize: '0.8rem',
                                            appearance: 'none',
                                            borderRadius: '0.25rem',
                                            width: '100%',
                                            borderColor: isDarkMode ? '#374151' : '#d1d5db',
                                            backgroundColor: isDarkMode ? '#000' : '#fff',
                                            color: isDarkMode ? '#fff' : '#000',
                                        }}
                                        onChange={handleSelectChange}
                                    />
                                    {errors.role && <p className={errorClass}>{errors.role.message}</p>}
                                </div>
                                <div>
                                    <label className={labelClass} htmlFor="name">
                                        Name
                                    </label>
                                    <input className={inputClass(errors.name)}
                                        placeholder="Enter Name"
                                        type="text"
                                        {...register('name')}
                                        onChange={handleInputChange}
                                    />
                                    {errors.name && <p className={errorClass}>{errors.name.message}</p>}
                                </div>
                                <div>
                                    <label className={labelClass} htmlFor="company_name">
                                        Company Name
                                    </label>
                                    <input
                                        className={inputClass(errors.company_name)}
                                        id="company_name"
                                        type="text"
                                        placeholder="Enter company name"
                                        {...register('company_name')}
                                        onChange={handleInputChange}
                                    />
                                    {errors.company_name && <p className={errorClass}>{errors.company_name.message}</p>}
                                </div>
                                <div>
                                    <label className={labelClass} htmlFor="email">
                                        Email
                                    </label>
                                    <input
                                        className={inputClass(errors.email)}
                                        id="email"
                                        type="email"
                                        placeholder="Enter email"
                                        {...register('email')}
                                    />
                                    {errors.email && <p className={errorClass}>{errors.email.message}</p>}
                                </div>

                                <div className="relative">
                                    <label className={labelClass} htmlFor="password">
                                        Password
                                    </label>
                                    <input
                                        className={`${inputClass(errors.password)} pr-9`}
                                        id="password"
                                        type={showPassword ? 'text' : 'password'}
                                        placeholder="Enter password"
                                        {...register('password')}
                                    />
                                    <span
                                        className="absolute right-3 top-[34px] cursor-pointer text-gray-400"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? <FiEyeOff size={14} /> : <FiEye size={14} />}
                                    </span>
                                    {errors.password && (
                                        <p className={errorClass}>{errors.password.message}</p>
                                    )}
                                </div>

                                <div>
                                    <label className={labelClass} htmlFor="department">
                                        Department
                                    </label>
                                    <input
                                        className={inputClass(errors.department)}
                                        id="department"
                                        type="text"
                                        placeholder="Enter department"
                                        {...register('department')}
                                        onChange={handleInputChange}
                                    />
                                    {errors.department && <p className={errorClass}>{errors.department.message}</p>}
                                </div>

                                <div>
                                    <label className={labelClass} htmlFor="phone">
                                        Phone
                                    </label>
                                    <input
                                        className={inputClass(errors.phone)}
                                        id="phone"
                                        type="tel"
                                        maxLength="10"
                                        placeholder="Enter 10 digit mobile no."
                                        {...register('phone')}
                                        onChange={handleInputChange}
                                    />
                                    {errors.phone && <p className={errorClass}>{errors.phone.message}</p>}
                                </div>
                            </div>

                            <div className="flex items-center justify-center mt-5">
                                <button
                                    className="bg-slate-800 dark:bg-white hover:opacity-80 text-white dark:text-black text-sm font-medium py-2.5 px-4 rounded focus:outline-none transition-all w-full"
                                    type="submit"
                                >
                                    {isSubmitting ? "Creating User..." : 'Create User'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddUser;